import axios from '@/plugins/axios'

export default {
  async postFile(url, request) {
    try {
      const response = await axios
        .post(url, request, { responseType: 'blob' })

      return this.getHttpResult(response)
    } catch (ex) {
      console.error(url, ex)

      return { success: false, message: 'Ocurrió una excepción inesperada.' }
    }
  },

  async apiCall(commit, serviceUri, data) {
    let action = serviceUri
    if (data.action != null && data.action.match(/^ *$/) === null) {
      action = `${action}/${data.action}`
    }

    let callModeVerb = 'get'
    switch (data.mode.toLowerCase()) {
      case 'select':
      case 'list':
        callModeVerb = 'get'
        break
      case 'insert':
        callModeVerb = 'post'
        break
      case 'update':
        callModeVerb = 'put'
        break
      case 'delete':
        callModeVerb = 'delete'
        break
      default:
        throw new Error('Invalid Call Mode')
    }

    return this.do(commit, callModeVerb, action, data.request)
  },

  async do(commit, verb, url, request) {
    try {
      commit('loader/pending', null, { root: true })

      const headers = {
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwibmFtZSI6IkFseEJHbGV6IDAxIiwiYWN0aXZlIjoxLCJleHAiOjE2NTEwMzg3NTR9.8kmjUPhTLryYVN-EfHzNZ0C8BYPHpgoFuDRq-zGvX2o',
      }

      let response

      if (
        request !== undefined
        && request.userKey === undefined
        && (verb === 'post' || verb === 'put')
      ) {
        const userData = JSON.parse(localStorage.getItem('userData'))
        if (userData != null && typeof userData.userKey === 'string' && !/^\s*$/.test(userData.userKey) && request !== null) {
          // eslint-disable-next-line no-param-reassign
          request.userKey = userData.userKey
        }
      }

      switch (verb.toLowerCase()) {
        case 'get':
          response = await axios
            .get(`${url}${this.objectToQueryString(request)}`, { headers })
          break
        case 'post':
          response = await axios
            .post(url, request, { headers })
          break
        case 'put':
          response = await axios
            .put(url, request, { headers })
          break
        case 'delete':
          response = await axios
            .delete(`${url}${this.objectToQueryString(request)}`, { headers })
          break
        default:
          throw new Error('Invalid HTTP Verb')
      }

      const result = this.getHttpResult(response)
      if (!result.success) {
        commit('errors/show', result.message, { root: true })
      }

      return result
    } catch (ex) {
      console.log('catch (ex)')
      console.log(ex)

      commit('errors/show', ex, { root: true })

      return { success: false, message: 'Ocurrió una excepción inesperada.' }
    } finally {
      commit('loader/done', null, { root: true })
    }
  },
  objectToQueryString(obj) {
    const str = []
    Object.keys(obj).forEach(key => {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    })

    return `?${str.join('&')}`
  },
  getHttpResult(response) {
    const result = { success: false, message: '', data: null }
    if (response.status === 200) {
      result.data = response.data
      result.success = true
    } else if (response.status === 204) {
      result.success = true
    } else if (response.status >= 400 && response.status < 500) {
      result.message = response.data.message
    } else if (response.status === 500) {
      result.message = `El servicio respondió con el error: ${response.data.message}`
    } else {
      result.message = `Respuesta inesperada: ${response.status}\n\n${response.data}`
    }

    return result
  },
}
